import apiInstance from '../../backend-api.setup'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

export const getTeamsService = () => apiInstance.get(ApiPathConfig.TEAMS)
